import { HttpService } from "../HttpService";

/**
 * Doctor token.
 * @param {string} bookingId
 * @returns {Promise<Object>}
 */
export async function doctorToken(
  bookingId: string,
) {
  const response = await HttpService.post(
    `${process.env.REACT_APP_API}/t4event/api/v01/federfarma/doctor/booking/${bookingId}/doctor-token`,
    {},
  );

  return response.data.result;
}
